import history from '../History';
import { setNotification } from './Notification';

import { fetchChildrenList } from './ChildrenList';

export const ADD_FULFILMENT_START = 'ADD_FULFILMENT_START';

export const ADD_FULFILMENT_SUCCESS = 'ADD_FULFILMENT_SUCCESS';

export const ADD_FULFILMENT_ERROR = 'ADD_FULFILMENT_ERROR';

export function createAddFulfilmentStartAction() {
  return {
    type: ADD_FULFILMENT_START
  };
}

export function createAddFulfilmentErrorAction(error) {
  return {
    type: ADD_FULFILMENT_ERROR,
    payload: {
      error: error
    }
  };
}

export function createAddFulfilmentSuccessAction(fulfilment) {
  return {
    type: ADD_FULFILMENT_SUCCESS,
    payload: {
      fulfilment: fulfilment
    }
  };
}

export function addFulfilment(fulfilment, child) {
  return dispatch => {
    dispatch(createAddFulfilmentStartAction());
    return fetch(process.env.REACT_APP_API_URL + '/api/v1/fulfilment', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(fulfilment)
    })
      .then(response => response.json())
      .then(json => {
        dispatch(createAddFulfilmentSuccessAction(json));
        dispatch(fetchChildrenList());
        history.push({
          pathname: '/thankyou',
          state: {
            fulfilment: json,
            child: child
          }
        });
      })
      .catch(error => {
        dispatch(createAddFulfilmentErrorAction('CONNECTION_FAILED'));

        // Notification message
        dispatch(
          setNotification({
            notificationType: 'error',
            message: 'Ooooops! Der Server antwortet nicht.'
          })
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/AddFulfilment.js